import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import { loyaltyPointsReducer , sendOtpReducer} from './modules/LoyaltyRedeem'

export default (store) => ({
  path: 'loyalty-redeem',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CustomerDetails = require('./containers/LoyaltyRedeem').default
      injectReducer(store, {key: 'loyaltyPoints', reducer: loyaltyPointsReducer})
      injectReducer(store, {key: 'otpInfo', reducer: sendOtpReducer})
      cb(null, CustomerDetails)
      /* Webpack named bundle   */
    }, 'categoryDetails')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LoyaltyRedeem/index.js